import { hasAccessToSurvey, isSurveyDismissed } from '../../features/OnboardingSurvey';
import { PrerenderUser, UserRole } from '../../features/PrerenderUser';

import * as KeycloakSession from '~features/auth/KeycloakSession';

type UserProps = Pick<
  PrerenderUser,
  'id' | 'companyCreationDate' | 'trackingCodeInstalled' | 'role' | 'onboardingSurveyCompleted'
>;

const INTEGRATION_WIZARD = '/integration-wizard';
// The wizard's own first step. Landing on the wizard root leaves the step to
// useWizardSteps, which lands a survey-less user here anyway — but only after a second
// navigation, so a freshly verified signup sees the dashboard shell flash first. Naming
// the step up front makes the verification link land on the survey directly (PRE-3267).
const ONBOARDING_SURVEY_STEP = `${INTEGRATION_WIZARD}/steps/onboarding-survey`;

function redirectIfNeeded(user: UserProps): string | undefined {
  const keycloakSessionFreshness = KeycloakSession.getFreshness();
  if (keycloakSessionFreshness === 'fresh') {
    KeycloakSession.setFreshness('stale');
    if (!user.trackingCodeInstalled && user.role !== UserRole.Guest) {
      // A user who already answered the survey must not be sent back to it; the wizard
      // root picks up their real next step.
      return user.onboardingSurveyCompleted ? INTEGRATION_WIZARD : ONBOARDING_SURVEY_STEP;
    }
  }

  // The dismissal is what makes the survey escapable at all — see SurveyDismissal
  // (PRE-3350).
  if (!hasAccessToSurvey(user.companyCreationDate) || user.onboardingSurveyCompleted || isSurveyDismissed()) {
    return;
  }

  // survey NOT completed
  if (user.trackingCodeInstalled) {
    return '/onboarding-survey';
  }

  return;
}

export default redirectIfNeeded;
